import { render } from "./ListaExecutantes.vue?vue&type=template&id=c61fb37c&scoped=true"
import script from "./ListaExecutantes.vue?vue&type=script&lang=js"
export * from "./ListaExecutantes.vue?vue&type=script&lang=js"

import "./ListaExecutantes.vue?vue&type=style&index=0&id=c61fb37c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c61fb37c"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QTable,QImg,QBtn,QCarousel,QCarouselSlide,QCarouselControl,QToggle,QCardSection});
